import { render, staticRenderFns } from "./EvaluacionesTabContent.vue?vue&type=template&id=35ba6e88"
import script from "./EvaluacionesTabContent.vue?vue&type=script&lang=js"
export * from "./EvaluacionesTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports